const HomeworkList = () =>
  import(
    /* webpackChunkName: "homework" */ '../../pages/study/Homework/List.vue'
  )
const MyHomework = () =>
  import(
    /* webpackChunkName: "homework" */ '../../pages/study/Homework/MyHomework.vue'
  )
const HomeworkIndex = () =>
  import(
    /* webpackChunkName: "homework" */ '../../pages/study/Homework/Index.vue'
  )
const HomeworkDetail = () =>
  import(
    /* webpackChunkName: "homework" */ '../../pages/study/Homework/Detail.vue'
  )
const CorrectTask = () =>
  import(
    /* webpackChunkName: "homework" */ '../../pages/study/Homework/Teacher/CorrectTask.vue'
  )
const CommentTask = () =>
  import(
    /* webpackChunkName: "homework" */ '../../pages/study/Homework/Teacher/CommentTask.vue'
  )
const StudentTask = () =>
  import(
    /* webpackChunkName: "homework" */ '../../pages/study/Homework/Teacher/StudentTask.vue'
  )

const ExamList = () =>
  import(/* webpackChunkName: "exam" */ '../../pages/study/Exam/List.vue')
const MyExam = () =>
  import(/* webpackChunkName: "exam" */ '../../pages/study/Exam/MyExam.vue')
const ExamIndex = () =>
  import(/* webpackChunkName: "exam" */ '../../pages/study/Exam/Index.vue')
const ExamDetail = () =>
  import(/* webpackChunkName: "exam" */ '../../pages/study/Exam/Detail.vue')
const ExamIntro = () =>
  import(/* webpackChunkName: "exam" */ '../../pages/study/Exam/ExamIntro.vue')
const CorrectExam = () =>
  import(
    /* webpackChunkName: "exam" */ '../../pages/study/Exam/Teacher/CorrectExam.vue'
  )
const CommentExam = () =>
  import(
    /* webpackChunkName: "exam" */ '../../pages/study/Exam/Teacher/CommentExam.vue'
  )
const StudentExam = () =>
  import(
    /* webpackChunkName: "exam" */ '../../pages/study/Exam/Teacher/StudentExam.vue'
  )

const CertList = () =>
  import(
    /* webpackChunkName: "cert" */ '../../pages/study/Certificate/CertList.vue'
  )

const CourseDetail = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/CourseDetail'
  )
const AudioDetail = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/AudioDetail'
  )
const VideoDetail = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/VideoDetail'
  )
const AuditPage = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/MpillegalPage'
  )
const ImageTextDetail = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/ImageTextDetail'
  )
const CoursePoster = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/CoursePoster'
  )
const CourseLessonList = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/CourseLessonList'
  )
const LearningMaterials = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/LearningMaterials'
  )
const ErrorPage = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/ErrorPage'
  )
const CourseMenuList = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/CourseMenuList'
  )
const HomeworkStudyList = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/HomeworkStudyList'
  )
const ExamStudyList = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/ExamStudyList'
  )
const SpecialDetail = () =>
  import(/* webpackChunkName: "special" */ '../../pages/study/Special/Detail')
const SpecialList = () =>
  import(/* webpackChunkName: "special" */ '../../pages/study/Special/List')

const CreditCenter = () =>
  import(
    /* webpackChunkName: "credit" */ '../../pages/study/Credit/CreditCenter'
  )
const CreditRank = () =>
  import(/* webpackChunkName: "credit" */ '../../pages/study/Credit/CreditRank')
const CreditTask = () =>
  import(/* webpackChunkName: "credit" */ '../../pages/study/Credit/CreditTask')
const CreditRecord = () =>
  import(
    /* webpackChunkName: "credit" */ '../../pages/study/Credit/CreditRecord'
  )
const CreditTaskDetail = () =>
  import(
    /* webpackChunkName: "credit" */ '../../pages/study/Credit/CreditTaskDetail'
  )
const LessonRelation = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/LessonRelation'
  )
const NoBindError = () => {
  return import(
    /* webpackChunkName: "course" */ '../../pages/study/CourseLesson/noBindError'
  )
}
const Transfer = () =>
  import(
    /* webpackChunkName: "course" */ '../../pages/study/URLScheme/transfer'
  )

const TrainRelation = () =>
  import(
    /* webpackChunkName: "TrainRelation" */ '../../pages/study/CourseLesson/TrainRelation'
  )

const ExchangeRecord = () =>
  import(
    /* webpackChunkName: "credit" */ '../../pages/study/Credit/exchange-record/index.vue'
  )
const GivingPresent = () =>
  import(
    /* webpackChunkName: "GivingPresent" */ '../../pages/study/CourseLesson/GivingPresent'
  )
export const STUDY_ROUTE_NAME = {
  AudioDetail: 'AudioDetail',
  VideoDetail: 'VideoDetail',
  ImageTextDetail: 'ImageTextDetail',
  ExamIntro: 'ExamIntro',
  CourseDetail: 'CourseDetail',
  CampDetail: 'CampDetail',
  SpecialDetail: 'SpecialDetail',
  LEARNING_STATISTICS: 'learningStatistics',
  CreditExchangeRecord: 'CreditExchangeRecord',
}

export default [
  {
    path: '/homework/mytask',
    meta: { title: '我的作业' },
    component: MyHomework,
  },
  {
    path: '/homework/list',
    meta: { title: '课堂作业' },
    component: HomeworkList,
  },
  {
    path: '/homework/index',
    meta: { title: '写作业' },
    component: HomeworkIndex,
  },
  {
    path: '/homework/detail',
    meta: { title: '作业详情' },
    component: HomeworkDetail,
  },
  {
    path: '/homework/correct/task',
    meta: { title: '作业' },
    component: CorrectTask,
  },
  {
    path: '/homework/comment/task',
    meta: { title: '点评作业' },
    component: CommentTask,
  },
  {
    path: '/homework/student/task',
    meta: { title: '学生作业' },
    component: StudentTask,
  },
  {
    path: '/exam/list',
    meta: { title: '考试列表' },
    component: ExamList,
  },
  {
    path: '/exam/mytask',
    meta: { title: '考试列表' },
    component: MyExam,
  },
  {
    name: STUDY_ROUTE_NAME.ExamIntro,
    path: '/exam/intro',
    meta: { title: '考试介绍' },
    component: ExamIntro,
  },
  {
    path: '/exam/index',
    meta: { title: '考试内容' },
    component: ExamIndex,
  },
  {
    path: '/exam/detail',
    meta: { title: '考试详情' },
    component: ExamDetail,
  },
  {
    path: '/exam/correct/task',
    meta: { title: '考试列表' },
    component: CorrectExam,
  },
  {
    path: '/exam/comment/task',
    meta: { title: '考试批阅' },
    component: CommentExam,
  },
  {
    path: '/exam/student/task',
    meta: { title: '学生考试' },
    component: StudentExam,
  },
  {
    path: '/cert/list',
    meta: { title: '学习证书' },
    component: CertList,
  },
  {
    name: STUDY_ROUTE_NAME.CourseDetail,
    path: '/course/detail',
    meta: { title: '' },
    component: CourseDetail,
  },
  {
    name: STUDY_ROUTE_NAME.AudioDetail,
    path: '/audio/detail',
    meta: { title: '' },
    component: AudioDetail,
  },
  {
    name: STUDY_ROUTE_NAME.VideoDetail,
    path: '/video/detail',
    meta: { title: '' },
    component: VideoDetail,
  },
  {
    path: '/video/audit-page',
    meta: { title: '' },
    component: AuditPage,
  },
  {
    name: STUDY_ROUTE_NAME.ImageTextDetail,
    path: '/image-text/detail',
    meta: { title: '' },
    component: ImageTextDetail,
  },
  {
    path: '/course/poster',
    // meta: { title: '海报' },
    component: CoursePoster,
  },
  {
    path: '/course-lesson/list',
    meta: { title: '课程列表' },
    component: CourseLessonList,
  },
  {
    path: '/learning/list',
    meta: { title: '学习资料' },
    component: LearningMaterials,
  },
  {
    path: '/credit/center',
    meta: { title: '学分中心' },
    component: CreditCenter,
  },
  {
    path: '/credit/center',
    meta: { title: '学分排行' },
    component: CreditCenter,
  },
  {
    path: '/credit/rank',
    meta: { title: '学分排行' },
    component: CreditRank,
  },
  {
    path: '/credit/task',
    meta: { title: '学分任务' },
    component: CreditTask,
  },
  {
    path: '/credit/record',
    meta: { title: '学分记录' },
    component: CreditRecord,
  },
  {
    path: '/credit/exchange-record',
    meta: { title: '学分兑换记录' },
    component: ExchangeRecord,
    name: STUDY_ROUTE_NAME.CreditExchangeRecord,
  },
  {
    path: '/credit/detail',
    meta: { title: '学分任务' },
    component: CreditTaskDetail,
  },
  {
    path: '/course/error',
    meta: { title: '' },
    component: ErrorPage,
  },
  {
    path: '/course-menu/list',
    meta: { title: '' },
    component: CourseMenuList,
  },
  {
    path: '/homework-study/list',
    meta: { title: '' },
    component: HomeworkStudyList,
  },
  {
    path: '/exam-study/list',
    meta: { title: '' },
    component: ExamStudyList,
  },
  {
    name: STUDY_ROUTE_NAME.SpecialDetail,
    path: '/special/detail',
    meta: { title: '' },
    component: SpecialDetail,
  },
  {
    path: '/special/list',
    meta: { title: '全部专栏' },
    component: SpecialList,
  },
  {
    path: '/lesson/relation',
    meta: { title: '' },
    component: LessonRelation,
  },
  {
    path: '/noBind',
    meta: {
      title: '',
    },
    component: NoBindError,
  },
  {
    name: 'Transfer',
    path: '/transfer',
    meta: { title: '' },
    component: Transfer,
  },
  {
    name: 'trainRelation',
    path: '/train/relation',
    meta: { title: '' },
    component: TrainRelation,
  },
  /**
   * 新版考试
   */
  {
    path: '/new-exam/intro',
    meta: { title: '考试介绍' },
    component: () =>
      import(
        /* webpackChunkName: "new-exam" */ '../../pages/study/TrainExam/Intro.vue'
      ),
  },
  {
    path: '/new-exam/index',
    meta: { title: '考试内容' },
    component: () =>
      import(
        /* webpackChunkName: "new-exam" */ '../../pages/study/TrainExam/Index.vue'
      ),
  },
  {
    path: '/new-exam/detail',
    meta: { title: '考试详情' },
    component: () =>
      import(
        /* webpackChunkName: "new-exam" */ '../../pages/study/TrainExam/Detail.vue'
      ),
  },
  {
    name: 'GivingPresent',
    path: '/train/givingPresent',
    meta: { title: '领取礼物' },
    component: GivingPresent,
  },
]
